export const parseNumericValue = (value: string) => {
  const numbersOnly = value.replace(/[^0-9.]/g, '')
  const numericValue = parseFloat(numbersOnly)
  return isNaN(numericValue) ? 0 : numericValue
}
